import './sentry'

import { loadRfComponents } from './rf-components-cdn'

/*
  Boot gate: in production builds the bare '@renderforest/rf-components' import (the color
  picker, alert popups, the notification center) resolves to the CDN copy captured on
  window.__V_EDITOR_RF_COMPONENTS__ — it must be loaded before anything renders, in BOTH
  mount modes, so even defining <v-editor-element> waits for it (custom elements upgrade
  when defined, the host loses nothing). See the rf-components-from-cdn plugin in
  vite.config.prod.ts and src/rf-components-cdn.ts; in every other build loadRfComponents
  resolves immediately.

  Sentry stays the first import; the app bootstrap itself lives in src/bootstrap.tsx.
*/
loadRfComponents().then(() => import('./bootstrap'))
